import React from 'react';
import './Disclaimer.css';

const Disclaimer: React.FC = () => {
  return (
    <div className="disclaimer-page">
      <h1>Disclaimer</h1>
      <p>
        Smart Rainmakers cannot and does not make any guarantees about your ability to achieve results or receive donation money through these programs, information, tools, or strategies.
      </p>
      <p>
        The program is designed to reward you for building your crowdfunding community. While the opportunity is unlimited, individual results will vary depending on multiple factors, including your level of commitment, individual effort, teamwork, and marketing skills.
      </p>
      <p>
        The numbers presented on the presentation are estimates prepared for your example illustrations, entertainment, and educational purposes. If income projections were presented to you prior to your registration, such projections are not representative of the donations you will definitely receive, if any, through your participation in the programs.
      </p>
      <p>
        Any and all donation projections should not be considered guarantees or predictions of your actual donations or contributions from the community. Success with the Smart Rainmakers community and programs results only from active participation and successful marketing efforts, which require work, commitment, and diligence on your part.
      </p>
    </div>
  );
};

export default Disclaimer;
